import { render, staticRenderFns } from "./SettingsManager.vue?vue&type=template&id=78d741ba&"
import script from "./SettingsManager.vue?vue&type=script&lang=ts&"
export * from "./SettingsManager.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports